import { IconProps, Organization } from 'grommet-icons';

export const ClientIcon: React.FC<IconProps> = (props) => <Organization size="24px" color="brand" {...props} />;
